export interface Prize {
  id: number;
  wheel_text: string;
  name: string;
  description: string;
  quantity: number;
  quantity_total: number;
  image: {
    file_name: string | null;
    file_url: string | null;
  };
}

export const TICKET_TYPES = ['deposit', 'sport', 'casino_wager', 'poker_hand', 'social'] as const;

export type TicketType = typeof TICKET_TYPES[number];

export interface Ticket {
  prize: Prize | null;
  type: TicketType;
}

export interface Day {
  date: string;
  is_today: boolean;
  tickets: Ticket[];
}

type TicketRulesLocales = {
  ticket_rules: Record<TicketType, string>;
};

type OtherLocales = {
  [K in string]: K extends keyof TicketRulesLocales ? never : string;
};

export type Locales = TicketRulesLocales & OtherLocales;

export interface LotteryProps {
  anonymous: boolean;
  days: Day[];
  prizes: Prize[];
  locales: Locales;
  start_date: string;
  end_date: string;
  lang: string;
  end_date_time: string;
}

export type LotteryDates = { start: string; end: string };

export type WheelState = 'stopped' | 'rotation' | 'slowdown' | 'congratulation';
